import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import util from '@utils/util';
import webLogin from '@utils/weblogin';
import videoService from '@services/videoService';
export default {
  name: 'TopGiftPage',
  props: {
    actIndex: String,
    hostid: String,
    videoid: String
  },
  data: function data() {
    return {
      VideoAPIService: null,
      pageIndex: 1,
      pageSize: 20,
      nextPage: false,
      list: []
    };
  },
  filters: {
    format: function format(val) {
      return util.nFormatter(val, 1);
    }
  },
  methods: {
    defaultUserPortrait: function defaultUserPortrait(userInfo) {
      return util.defaultUserPortrait(userInfo);
    },
    turnHttps: function turnHttps(url) {
      if (url) {
        return util.forceHttps(url);
      }
      return '';
    },
    getLevelImage: function getLevelImage() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return "url(/app/static/images/blank_level/".concat(Math.floor(level / 10), "0-").concat(Math.floor(level / 10), "9.png)");
    },
    liveContribution: function liveContribution() {
      var _this = this;
      if (!this.videoid || !this.hostid) {
        return;
      }
      try {
        this.VideoAPIService.getNobleList(this.videoid, this.hostid, util.getI18nLocale()).then(function (data) {
          // 过滤隐身用户（神秘人除外）
          _this.list = data.filter(function (item) {
            return item.inVisible === '0' || item.is_mysterious == 1;
          });
        }).catch(function () {});
      } catch (e) {
        console.log(e);
      }
    },
    totalContribution: function totalContribution() {
      var _this2 = this;
      var isfresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!webLogin.checkLogin()) {
        return;
      }
      var uinfo = webLogin.getUserInfoData();
      if (isfresh) {
        this.pageIndex = 1;
      }
      var param = _objectSpread({
        tuid: uinfo.uid,
        hostid: this.hostid,
        androidid: uinfo.deviceid,
        // countryCode: US
        page: this.pageIndex,
        pagesize: this.pageSize
      }, uinfo);
      this.VideoAPIService.getTopContribute(param).then(function (data) {
        if (isfresh) {
          _this2.list = [];
        }
        _this2.list = _this2.list.concat(data);
        if (data && data.length === _this2.pageSize) {
          _this2.nextPage = true;
        } else {
          _this2.nextPage = false;
        }
      }).catch(function () {});
    },
    opencard: function opencard(item, e) {
      // 神秘人业务 不打开卡片
      if (item && item.is_mysterious == 1) {
        return;
      }
      this.$emit('opencard', item.uid, 1, e);
    },
    initData: function initData() {
      var isfresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.actIndex === '0') {
        this.liveContribution();
      } else if (this.actIndex === '1') {
        this.totalContribution(isfresh);
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;
    this.VideoAPIService = videoService.createApi();
    if (this.videoid && this.hostid) {
      this.initData(true);
    }
    if (this.actIndex === '1') {
      var watchDiv = this.$refs.watchDiv;
      watchDiv.addEventListener('scroll', function () {
        var sTop = 0;
        var sHei = 0;
        var dHei = 0;
        // 初始化滚动条
        sTop = watchDiv.scrollTop;
        sHei = watchDiv.clientHeight;
        dHei = watchDiv.scrollHeight;
        if (Math.ceil(sTop) >= dHei - sHei - 0 && _this3.nextPage) {
          _this3.nextPage = false;
          // eslint-disable-next-line no-plusplus
          _this3.pageIndex++;
          _this3.totalContribution();
        }
      }, false);
    }
  },
  created: function created() {}
};